import axios from "axios";
const uri = "https://api-baza-wiedzy.klett.pl/";
//const uri = "http://localhost:3001/";

export function getCategoriesByLanguage(language){
  return axios.get(uri + "categories?language=" + language);
}

export function getPreSchoolItemsByCategory(language, cateory){
  return axios.get(uri + "categories/pre-edu?language="+language+"&category=" + cateory, {
    headers: {
      "Authorization" : "Bearer " + localStorage.getItem("jwt")
    }
  });
}

export function getItemsTitleListByLanguage(language){
  return axios.get(uri + "categories/pre-edu-title-list?language=" + language, {
    headers: {
      "Authorization" : "Bearer " + localStorage.getItem("jwt")
    }
  });
}

export function getItemsListBySearchQuery(language, query){
  return axios.get(uri + "categories/search?language=" + language + "&query=" + query, {
    headers: {
      "Authorization" : "Bearer " + localStorage.getItem("jwt")
    }
  });
}

export function getItemDetailsByLanguageCategorySlug(language, category, slug){
  return axios.get(uri + "categories/item-details?language=" + language + "&category=" + category + "&slug=" + slug, {
    headers: {
      "Authorization" : "Bearer " + localStorage.getItem("jwt")
    }
  });
}

export function getCategoriesByBook(language, slug){
  return axios.get(uri + "categories/book-details?language=" + language + "&slug=" + slug, {
    headers: {
      "Authorization" : "Bearer " + localStorage.getItem("jwt")
    }
  });
}

//  AUTH
export function postUserAuth(username, password){
  return axios.post(uri + "user/authenticate", {username: username, password: password});
}

export function checkUserJwt(jwt){
  return axios.get(uri + "user/me", {
    headers: {
      "Authorization" : "Bearer " + jwt
    }
  })
}

export function getUserByJwt(jwt){
  return axios.get(uri + "user/get-data-by-jwt", {
    headers: {
      "Authorization" : "Bearer " + jwt
    }
  });
}

export function downloadFileByHash(hash, language){
  return axios.get(uri + "categories/download-file?hash=" + hash + "&subject=" + language, 
    {
      responseType: 'blob',
      headers: {
        "Authorization" : "Bearer " + localStorage.getItem("jwt")
      }
    }
  )

 
}


//  PDF
export function returnPdfUrl(hash, id, language){
  const jwt = localStorage.getItem("jwt");
  if(jwt !== null){
    return uri + "categories/pdf-file-content?hash=" + hash + "&lang=" + language + "&id=" + id + "&token=" + jwt
  }
  
  return uri + "categories/pdf-file-content?hash=" + hash + "&lang=" + language + "&id=" + id

}